import { LIST_STYLES as e } from "../../constants/default-styles.mjs";
import { useGetParentCount as t } from "./use-get-parent-count.mjs";
import { getOrderedListStyleType as n } from "./utils/list.mjs";
import { NodeViewContent as r, NodeViewWrapper as i } from "@tiptap/react";
import { useEffect as a } from "react";
import { jsx as o } from "react/jsx-runtime";
//#region src/extensions/list-extension/custom-ordered-list.tsx
var s = ({ getPos: s, editor: c, updateAttributes: l }) => {
	let { realDepth: u } = t({
		editor: c,
		getPos: s,
		nodeName: "orderedList"
	});
	return a(() => {
		setTimeout(() => {
			l({ depth: u });
		});
	}, [u, l]), /* @__PURE__ */ o(i, {
		as: "ol",
		style: {
			...e,
			listStyleType: n(u)
		},
		children: /* @__PURE__ */ o(r, {})
	});
};
//#endregion
export { s as CustomOrderedList };
